import axios from "axios";
import { getIdToken } from "utils";

const storageClient = {
  // Upload a file to storage
  async upload({ presignedUrl, file, metadata, onProgress, }) {
    const headers = {
      "Content-Type": file.type,
    };

    // Add all metadata headers (must match what was signed on the server)
    for (const [key, value] of Object.entries(metadata)) {
      headers[`x-amz-meta-${key.toLowerCase()}`] = value.normalize("NFC");
    }

    try {
      const result = await axios.put(presignedUrl, file, 
        { 
          headers, 
          onUploadProgress: onProgress, 
        });

      return result;
    } catch (error) {
      console.error("Upload Error:", error);
      throw error;
    }
  },
  async list({ key }) {
    if (!key) {
      throw new Error("Missing required parameter: key");
    }

    try {
      const idToken = await getIdToken();
      if (!idToken) {
        throw new Error("User is not authenticated or token is missing.");
      }

      const response = await axios.get(process.env.REACT_APP_R2_LIST_URL, {
        params: { key: key },
        headers: { 
          Authorization: `Bearer ${idToken}`,
        },
      });

      return response.data.files; // paths are already clean
    } catch (error) {
      console.error("List Error:", error);
      throw error;
    }
  },
  async remove( keys ) {
    if (!keys) 
      throw new Error("Missing required parameter: keys");

    const idToken = await getIdToken();

    try {
      const response = await axios.post(
        process.env.REACT_APP_R2_DELETE_URL,
        { keys }, // ✅ POST body — JSON object with "keys"
        {
          headers: {
            Authorization: `Bearer ${idToken}`, // ✅ Correct location for headers
            "Content-Type": "application/json",
          },
        }
      );
      return response;
    } catch (error) {
      console.error("Remove Error:", error);
      throw error;
    }
  },
};

export default storageClient;
